import {
  IonCol, IonGrid, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption,
} from '@ionic/react';
import React, { useEffect, useState } from 'react';

import {
  Widget, WidgetPosition, widgetPositionOptions, WidgetSection,
} from '../../../../interfaces/PluginInterface/PluginInterface';
import classNames from 'classnames';
import styles from '../../Plugin.module.scss';
import stylesConfig from '../PluginConfig.module.scss';

interface PluginFormProps {
  formData?: WidgetSection;
  widgetType?: Widget;
  productWidgetDVN: boolean;
  handleInputUpdate: (arg0: any) => void;
}

export const WidgetFormWrapper: React.FC<PluginFormProps> = ({ formData,
  widgetType,
  handleInputUpdate,

  productWidgetDVN }) => {


  return (<IonGrid>
    {formData?.section === 'catalog' ? (
      <IonRow
        className={classNames(styles.pluginInputWrapper, styles.onlyWidgetSection)}>
        <IonCol size="12" size-md="5.75">
          <div
            className={classNames(styles.inputContainer)}>
            <IonLabel className={classNames(styles.labelWidgeForm)}>
              Selector css de widget
            </IonLabel>
            <IonInput
              disabled={!productWidgetDVN}
              name="dom_widget"
              placeholder="Selector CSS del elemento donde se pintará el widget"
              className={classNames(
                styles.pluginInput,
                styles.widgetInput,
                widgetType?.type === 'DVN' ? styles.widgetStdInput : styles.widgetStdInput,
              )}
              value={widgetType?.dom_widget}
              onIonInput={(e) => {
                handleInputUpdate(e);
              }}
              onIonChange={handleInputUpdate}
            />
          </div>
        </IonCol>
        <IonCol size="0" size-md="0.5" />
        <IonCol size="12" size-md="5.75">
          <IonLabel className={classNames(styles.labelWidgeForm)}>
            Posición de widget
          </IonLabel>
          <IonSelect
            disabled={!productWidgetDVN}
            name="position"
            labelPlacement="stacked"
            placeholder="Posición widget"
            interface="popover"
            className={classNames(
              styles.pluginInput,
              stylesConfig.pluginSelect, widgetType?.type === 'DVN' ? styles.widgetStdInput : styles.widgetStdInput)}
            value={widgetType?.position}
            onIonChange={handleInputUpdate}
          >
            {widgetPositionOptions.map((option: WidgetPosition) => <IonSelectOption key={option.value} value={option.value}>{option.name}</IonSelectOption>)}
          </IonSelect>
        </IonCol>
      </IonRow>
    ) :
      (
        <>
          <IonRow
            className={classNames(styles.pluginInputWrapper)}>
            <IonLabel className={classNames(styles.labelWidgeForm)}>
              Selector css de widget
            </IonLabel>
            <IonInput
              disabled={!productWidgetDVN}
              name="dom_widget"
              placeholder="Selector CSS del elemento donde se pintará el widget"
              value={widgetType?.dom_widget}
              onIonChange={handleInputUpdate}
              onIonInput={(e) => {
                handleInputUpdate(e);
              }}
              className={classNames(
                styles.pluginInput,
                styles.widgetInput,
                widgetType?.type === 'DVN' ? styles.widgetStdInput : styles.widgetStdInput,
              )}
            />

          </IonRow>
          <IonRow className={classNames(styles.pluginInputWrapper)}>
            <IonLabel className={classNames(styles.labelWidgeForm)}>
              Posición de widget
            </IonLabel>
            <IonSelect
              disabled={!productWidgetDVN}
              name="position"
              labelPlacement="stacked"
              placeholder="Posición widget"
              interface="popover"
              className={classNames(
                styles.pluginInput,
                stylesConfig.pluginSelect, widgetType?.type === 'DVN' ? styles.widgetStdInput : styles.widgetStdInput)}
              value={widgetType?.position}
              onIonChange={handleInputUpdate}
              onInput={handleInputUpdate}

            >
              {widgetPositionOptions.map((option: WidgetPosition) => <IonSelectOption key={option.value} value={option.value}>{option.name}</IonSelectOption>)}
            </IonSelect>
          </IonRow>
        </>
      )}
    {formData?.section === 'checkout'
      && (
        <>
          <IonRow className={classNames(styles.pluginInputWrapper)}>
            <IonLabel className={classNames(styles.labelWidgeForm)}>
              Selector css de check de pago
            </IonLabel>
            <IonInput
              disabled={!productWidgetDVN}
              name="dom_payment_check"
              placeholder="Selector CSS del check de pago"
              className={classNames(
                styles.pluginInput,
                styles.widgetInput, widgetType?.type === 'DVN' ? styles.widgetStdInput : styles.widgetStdInput)}
              value={widgetType?.dom_payment_check}
              onIonChange={handleInputUpdate}
            />
          </IonRow>
          <IonRow className={classNames(styles.pluginInputWrapper)}>
            <IonLabel className={classNames(styles.labelWidgeForm)}>
              Selector css de la clase de pago
            </IonLabel>
            <IonInput
              disabled={!productWidgetDVN}
              name="dom_payment_class"
              placeholder="Selector CSS de la clase de pago"
              className={classNames(
                styles.pluginInput,
                styles.widgetInput, widgetType?.type === 'DVN' ? styles.widgetStdInput : styles.widgetStdInput)}
              value={widgetType?.dom_payment_class}
              onIonChange={handleInputUpdate}
            />
          </IonRow>
          {formData?.section === 'checkout'
            &&
            (
              <IonRow className={classNames(styles.pluginInputWrapper)}>
                <IonLabel className={classNames(styles.labelWidgeForm)}>
                  Selector CSS del elemento pago de pepper
                </IonLabel>
                <IonInput
                  disabled={!productWidgetDVN}
                  name="dom_payment"
                  placeholder="Selector CSS de la clase de pago"
                  className={classNames(
                    styles.pluginInput,
                    styles.widgetInput, widgetType?.type === 'DVN' ? styles.widgetStdInput : styles.widgetStdInput)}
                  value={widgetType?.dom_payment}
                  onIonChange={handleInputUpdate}
                />
              </IonRow>
            )}
        </>
      )}

  </IonGrid>

  );
};

